import { createSlice } from '@reduxjs/toolkit';

const initialState = {
	superiors: null,
	subordinates: null,
	checkedWavesIds: [],
};

export const productionControl = createSlice({
	name: 'productionControl-reportModal',
	initialState,
	reducers: {
		setModalSuperiors: (state, { payload }) => ({
			...state,
			superiors: payload,
		}),
		resetModalSuperiors: (state) => ({
			...state,
			superiors: initialState.superiors,
		}),
		setModalSubordinates: (state, { payload }) => ({
			...state,
			subordinates: payload,
		}),
		resetModalSubordinates: (state) => ({
			...state,
			subordinates: initialState.subordinates,
		}),
		setCheckedWave: (state, { payload: id }) => {
			let newCheckedWavesIds;
			const { checkedWavesIds } = state;
			const alreadyExists = checkedWavesIds.some((item) => item === id);
			if (alreadyExists) {
				newCheckedWavesIds = checkedWavesIds.filter((item) => item !== id);
			} else {
				newCheckedWavesIds = [...checkedWavesIds, id];
			}

			return {
				...state,
				checkedWavesIds: newCheckedWavesIds,
			};
		},
		resetCheckedWavesIds: (state) => ({
			...state,
			checkedWavesIds: initialState.checkedWavesIds,
		}),
	},
});

export default productionControl.reducer;
export const REDUCER_NAME = productionControl.name;

export const {
	setModalSuperiors,
	resetModalSuperiors,
	setModalSubordinates,
	resetModalSubordinates,
	setCheckedWave,
	resetCheckedWavesIds,
} = productionControl.actions;
